export default __webpack_public_path__ + "static/media/15.6f91e327.jpg";